import { render, staticRenderFns } from "./storeprice_changes.vue?vue&type=template&id=5c108896"
import script from "./storeprice_changes.vue?vue&type=script&lang=js"
export * from "./storeprice_changes.vue?vue&type=script&lang=js"
import style0 from "./storeprice_changes.vue?vue&type=style&index=0&id=5c108896&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports